import { buildQuery, requestJson } from "./apiClient";

export async function listUsers(params = {}) {
  return requestJson(`/api/admin/users${buildQuery(params)}`);
}

export async function getUser(userId) {
  return requestJson(`/api/admin/users/${userId}`);
}

export async function createUser(payload) {
  return requestJson("/api/admin/users", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function sendUserInvite(userId) {
  return requestJson(`/api/admin/users/${userId}/invite`, {
    method: "POST",
  });
}

export async function updateUser(userId, payload) {
  return requestJson(`/api/admin/users/${userId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function assignRoles(userId, roles) {
  return requestJson(`/api/admin/users/${userId}/roles`, {
    method: "POST",
    body: JSON.stringify({ roles }),
  });
}

export async function removeRole(userId, roleCode) {
  return requestJson(`/api/admin/users/${userId}/roles/${encodeURIComponent(roleCode)}`, {
    method: "DELETE",
  });
}

export async function activateUser(userId) {
  return requestJson(`/api/admin/users/${userId}/activate`, {
    method: "POST",
  });
}

export async function deactivateUser(userId) {
  return requestJson(`/api/admin/users/${userId}/deactivate`, {
    method: "POST",
  });
}

export async function listRoles() {
  return requestJson("/api/admin/roles/catalog");
}

export async function getUserAudit(userId, params = {}) {
  return requestJson(`/api/admin/users/${userId}/audit${buildQuery(params)}`);
}
